var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recommended-svgrepo-com 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x94\x8D-Product-Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_recommended_24_regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8-Color",
    d: "M9.50008 1.58325C12.9979 1.58325 15.8334 4.41878 15.8334 7.91659C15.8334 9.93382 14.8903 11.7308 13.421 12.8906L13.4597 12.8598L13.459 17.6108C13.459 18.0456 13.007 18.3329 12.6133 18.1484L9.5005 16.6897L6.38938 18.1484C5.99565 18.333 5.54358 18.0457 5.54358 17.6108L5.5423 12.8613C4.09499 11.7023 3.16675 9.91787 3.16675 7.91659C3.16675 4.41878 6.00228 1.58325 9.50008 1.58325ZM12.2719 13.6128L12.3037 13.5971C11.4586 14.015 10.5068 14.2499 9.50008 14.2499C8.60913 14.2499 7.76115 14.0659 6.99205 13.7339L6.73068 13.6139L6.73108 16.6767L9.24839 15.4964C9.40804 15.4216 9.59271 15.4215 9.75239 15.4964L12.2715 16.6768L12.2719 13.6128ZM9.50008 2.77075C6.65812 2.77075 4.35425 5.07462 4.35425 7.91659C4.35425 10.7586 6.65812 13.0624 9.50008 13.0624C12.342 13.0624 14.6459 10.7586 14.6459 7.91659C14.6459 5.07462 12.342 2.77075 9.50008 2.77075ZM9.6812 5.25844L10.4036 6.72512L12.0218 6.95895C12.1875 6.9829 12.2537 7.18653 12.1338 7.30338L10.9634 8.44375L11.2397 10.0551C11.268 10.2201 11.0947 10.3459 10.9466 10.2679L9.50008 9.50592L8.05354 10.2679C7.90535 10.3459 7.73204 10.22 7.76048 10.0549L8.03813 8.44375L6.86647 7.30346C6.74644 7.18665 6.81264 6.9829 6.97841 6.95895L8.59655 6.72512L9.31896 5.25844C9.39297 5.10819 9.6072 5.10819 9.6812 5.25844Z",
    fill: "url(#paint0_linear_3813_153957)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3813_153957",
    x1: 9.50008,
    y1: 1.58325,
    x2: 9.50008,
    y2: 18.2053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0977D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053F71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedIcon);
export default __webpack_public_path__ + "static/media/recommended-icon.412cb1a99ec0c94c0dcdc7de3b110886.svg";
export { ForwardRef as ReactComponent };